import { render, staticRenderFns } from "./DepositStatement.vue?vue&type=template&id=5fcb619c"
import script from "./DepositStatement.vue?vue&type=script&lang=js"
export * from "./DepositStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports